import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from '../../miProfile/Field';
import { DateInput } from '../../DateInput';

import { style } from '../../../../helpers/editStyle';
import { unSelectFundDistribution } from '../../../../store/fundDistribution/fundDistributionSlice';
import { NumberInput } from '../../NumberInput';
import { editFundDistribution } from '../../../helpers/fundDistribution';

export const EditDistributionFund = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { dataToAction } = useSelector(state => state.fundDistribution)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);

    const { urlVideo, amount, participationValuation, investmentDate, investmentType } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectFundDistribution())
        setHidden(false)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        const participation = investmentType === 'Ampliación Capital' ? participationValuation : null
        const update = urlVideo !== dataToAction.urlVideo ? true : false
        await editFundDistribution({...formValues, participationValuation:participation, update, fundId: searchParams.get('fund') }, t('funds.successEditMsg'), t('funds.errorEditMsg'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('funds.editFundsDistribution')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Field name={urlVideo} title='urlVideo' handleInputChange={handleInputChange} translation='funds' />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <DateInput name={investmentDate} title='investmentDate' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput name={amount} title='amount' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >

                            <Grid item xs={12} padding='0 5px'>
                                <Typography variant='overline' color='secondary'>{t('opportunities.investmentType')}</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={['Ampliación Capital', 'Préstamo Convertible']}
                                    size='small'
                                    renderInput={(params) => <TextField  {...params} variant='outlined' name='investmentType' />}
                                    value={investmentType}
                                    onSelect={handleInputChange}
                                    fullWidth
                                    required
                                />
                            </Grid>

                        </Grid>

                        <Grid container direction='row' width='100%' >
                            {
                                investmentType === 'Ampliación Capital' &&
                                <Grid item xs={12} padding='0 5px'>
                                    <NumberInput min={0} name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true} />
                                </Grid>
                            }
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}